var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dup__media__call__btn" },
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover",
              modifiers: { hover: true }
            }
          ],
          staticClass: "duplicate-media-call-btn",
          attrs: { title: "Duplicate", variant: "theme" },
          on: { click: _vm.createNewDeliverableTemplateFromId }
        },
        [_c("i", { staticClass: "fas fa-copy" })]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }